<template>
  <section class="cr-list txn-list" aria-label="Transaction records">
    <div class="cr-list__head">
      <div class="cr-list__columns txn-list__columns" aria-hidden="true">
        <span>Date</span>
        <span>Type</span>
        <span>Category</span>
        <span>Credits</span>
        <span>Call duration</span>
        <span>Balance</span>
      </div>
    </div>

    <div class="cr-list__scroll">
      <div v-if="loading" class="cr-list__body">
        <div v-for="n in 8" :key="n" class="cr-row txn-row cr-row--skeleton" />
      </div>

      <div v-else-if="transactions.length" class="cr-list__body" role="list">
        <TransactionsRow
          v-for="transaction in transactions"
          :key="transaction.id"
          :transaction="transaction"
          :organization="organization"
        />
      </div>

      <div v-else-if="isSearchActive" class="cr-empty">
        <v-icon icon="mdi-magnify-close" size="40" class="cr-empty__icon" />
        <p class="cr-empty__title">No matching transactions</p>
        <p class="cr-empty__subtitle">Try another search or clear the app bar filter.</p>
      </div>

      <div v-else class="cr-empty">
        <v-icon icon="mdi-swap-horizontal" size="40" class="cr-empty__icon" />
        <p class="cr-empty__title">No transactions yet</p>
        <p class="cr-empty__subtitle">
          Credit and debit activity will appear here.
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import TransactionsRow from '@/components/Transactions/TransactionsRow.vue'

defineOptions({ name: 'TransactionsList' })

defineProps({
  transactions: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  isSearchActive: { type: Boolean, default: false },
  organization: { type: Object, default: () => ({}) },
})
</script>
